import React from 'react';
import cx from 'classnames';
import tinycolor from 'tinycolor2';

import style from './style.module.scss';
import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  children: React.ReactNode | string;
  className?: string;
}

const WarningAlert: React.FC<Props> = (props) => {
  return (
    <div
      className={cx(style.warning, props.className, 'u-padding-A-xs text-body')}
      style={{
        backgroundColor: tinycolor(colors.brandWarning).lighten(30).toString(),
        borderColor: colors.brandWarning,
        borderWidth: '0px 0px 2px',
        borderStyle: 'solid',
        color: colors.brandWarning
      }}
    >
      {typeof props.children === 'string' ? <span dangerouslySetInnerHTML={{__html: props.children }} /> : props.children}
    </div>
  );
};

export default WarningAlert;
